import withQuerystringResults from '../../../../../../components/Blocks/Listing/withQuerystringResults';

export default withQuerystringResults;
